import { render, staticRenderFns } from "./AppCardModal.global.vue?vue&type=template&id=1f985fb6&functional=true&"
import script from "./AppCardModal.global.vue?vue&type=script&lang=js&"
export * from "./AppCardModal.global.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports